<!--/**-->
<!--* @author "tianweiling1"-->
<!--* @Email:"tianweiling1@jd.com",-->
<!--* @LastEditTime "2021/10/21 8:39 下午"-->
<!--* @Description: ""-->
<!--*/-->
<template>
    <div class="pre-audit">
        <div class="steps-wrapper">
            <el-steps align-center>
                <el-step
                    v-for="(step, index) in steps"
                    :key="step"
                    :title="step"
                    :status="isStepFinish(index + 1)"
                />
            </el-steps>
        </div>
        <div class="form-wrapper">
            <!-- 回显字段，仅第一步显示 -->
            <p v-if="currentStep === 1">
                <span
                    :style="{
                        width: '140px',
                        textAlign: 'right',
                        paddingRight: '12px'
                    }"
                    class="form-text"
                    >所属部门</span
                >
                <span class="form-text">{{ departName }}</span>
            </p>
            <p v-if="currentStep === 1">
                <span
                    :style="{
                        width: '140px',
                        textAlign: 'right',
                        paddingRight: '12px'
                    }"
                    class="form-text"
                    >商家类型</span
                >
                <span class="form-text">{{
                    MERCHANT_TYPE.getDescFromValue(merchantType)
                }}</span>
            </p>
            <render-container
                v-for="(template, index) in montageTemplateList"
                :key="template.id"
                v-show="currentStep === index + 1"
                :schema="schemaObject[template.id]"
                :formData="formData"
                :formRulesProps="formRules"
                :ref="`template_${template.id}`"
                :class="`template_${template.id}`"
            ></render-container>
        </div>
        <div class="btns-wrapper">
            <el-button v-show="hasPreviousStep" @click="goPrev" type="plain"
                >上一步</el-button
            >
            <el-button @click="goNext" :loading="isLoading" type="primary">{{
                nextBtnText
            }}</el-button>
        </div>
    </div>
</template>

<script>
import { v1 as uuid } from 'uuid'
import { parseJSONString, findDescendantByName } from './../../common/utils'
import addMixins from './../../common/mixins/addMixins'
import getMixins from './../../common/mixins/getMixins'
import { MERCHANT_TYPE } from './../../common/constants'
import { Cascader } from 'element-ui'

export default {
    name: 'pre-audit',
    data() {
        return {
            channelNo: null,
            uuid: null,
            departId: null,
            merchantType: null,
            departName: null,
            MERCHANT_TYPE,
            businessParams: null,
            elCascaderRef: null
        }
    },
    created() {
        // generate uuid
        this.uuid = uuid()
        // get params from query
        const {
            channelNo,
            departId,
            departName,
            merchantType
        } = this.$route.query
        // save variables
        this.channelNo = channelNo
        this.departId = departId
        this.merchantType = merchantType
        this.departName = departName
        this.businessParams = { channelNo, departId, merchantType }
        // get montage model object
        this.$apiServe.computerSettleIn
            .getMerchantMontage({
                channelNo,
                merchantType,
                departId,
                uuid: this.uuid
            })
            .then(res => {
                // --------添加字段联动属性-------
                // 给关联根字段添加 rule 联动属性
                let relationData = this.addRelation(res, businessParams)
                res.marketTemplateConfigInfo.templateDetailList =
                    relationData.templateDetailList
                // ---------------
                // 获取排序的模版
                this.montageTemplateList = this.getMontageTemplateList(res)
                const businessParams = { departId, merchantType }
                // 生成每个模版的schema
                this.schemaObject = this.getSchemaObject(
                    this.montageTemplateList,
                    businessParams
                )
                // 合并表单和已保存数据，如果有保存的数据，数据需回填
                this.formData = this.getFormData(this.montageTemplateList, res)
                // get all field list
                this.formRules = this.getFormRules(
                    this.montageTemplateList,
                    businessParams
                )
                // 确定当前模版 res.currentTemplateId 已完成的模版
                this.currentStep = this.getCurrentStep(
                    this.montageTemplateList,
                    res
                )
            })
    },
    methods: {
        goNext() {
            // 前端校验
            // 当前表单信息
            const currentTemplate = this.montageTemplateList[
                this.currentStep - 1
            ]
            const currentFormFieldList = currentTemplate.templateFieldParamList.map(
                field => ({
                    ...field,
                    configSetting: parseJSONString(field.configSetting, {})
                })
            )
            console.log(currentFormFieldList)
            // TODO 获取激活的form container retaiForm elForm
            this.$refs[
                `template_${currentTemplate.id}`
            ][0].$children[0].$refs.searchForm.validate(valid => {
                // 联动表单校验 formcreat 组件的校验结果
                let FCValid = this.FormCreatValidate(
                    this.formData,
                    currentFormFieldList
                )
                // 判断校验结果
                if (!valid || !FCValid) {
                    return
                }
                // 合并所有表单 formData
                const currentFormData = this.addRelationFieldValue(
                    this.formData,
                    currentFormFieldList
                )
                console.log(this.formData)
                console.log(Object.keys(this.formData))
                console.log(currentFormData)
                console.log(Object.keys(currentFormData))
                console.log(
                    this.addRelationFieldList(
                        currentFormFieldList,
                        this.formData
                    )
                )
                //判断是否有营业执照
                const merchant_spec_bizLicense_ImgText =
                    currentFormData['merchant_spec_bizLicense-ImgText'] || []
                const merchant_base_businessRegisNumber_find =
                    merchant_spec_bizLicense_ImgText &&
                    merchant_spec_bizLicense_ImgText.find(
                        item => item.key === 'merchant_base_businessRegisNumber'
                    )
                // 有营业执照 特殊校验 蓝鲸校验
                if (
                    this.currentStep === this.totalStep &&
                    merchant_base_businessRegisNumber_find
                ) {
                    // 营业执照与公司名称校验
                    const { merchant_base_companyName } = currentFormData

                    const merchant_base_businessRegisNumber =
                        merchant_base_businessRegisNumber_find.value
                    this.$apiServe.computerSettleIn
                        .checkMerchantCompanyBlueWhale({
                            merchant_base_companyName,
                            merchant_base_businessRegisNumber
                        })
                        .then(() => {
                            // 校验通过，继续提交
                            this.saveForm(
                                currentTemplate.id,
                                currentFormFieldList,
                                currentFormData
                            )
                        })
                        .catch(err => {
                            console.log(err)
                            this.$confirm(err.msg, '提示', {
                                confirmButtonText: '继续提交',
                                cancelButtonText: '取消',
                                type: 'warning'
                            })
                                .then(() => {
                                    // 继续提交
                                    this.saveForm(
                                        currentTemplate.id,
                                        currentFormFieldList,
                                        currentFormData
                                    )
                                })
                                .catch(() => {
                                    // 返回继续修改
                                    return
                                })
                        })
                } else {
                    this.saveForm(
                        currentTemplate.id,
                        currentFormFieldList,
                        currentFormData
                    )
                }
            })
        },
        saveForm(currentTemplateId, currentFormFieldList, currentFormData) {
            let params = {
                data: currentFormData,
                currentTemplateId,
                channelNo: this.channelNo,
                finished: this.currentStep === this.totalStep,
                uuid: this.uuid,
                departId: this.departId,
                // 当前页面表单 字段
                fieldList: this.addRelationFieldList(
                    currentFormFieldList,
                    this.formData
                ),
                merchantType: this.merchantType
            }
            // 非堵塞特殊处理
            // TODO 发送多选地址的name，多级地址，只能有一个
            // ---------------------------------------
            this.elCascaderRef = findDescendantByName(this, Cascader.name)
            if (this.elCascaderRef) {
                params.data.merchant_ext_mutiBusinessZoneNameList = this.elCascaderRef.presentTags.map(
                    ({ text }) => ({ text })
                )
                params.fieldList.push('merchant_ext_mutiBusinessZoneNameList')
            }
            // ---------------------------------------
            // TODO loading decorator
            this.isLoading = true
            this.$apiServe.computerSettleIn
                .saveMerchantForm(params)
                .then(res => {
                    console.log(res)
                    this.currentStep++
                    if (this.isFinish) {
                        // go to detail page
                        // this.$message.success('保存成功，信息待审核')
                        this.$router.replace({
                            name: 'detailMerchantComputerSettleIn',
                            query: this.businessParams
                        })
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    },
    mixins: [addMixins, getMixins]
}
</script>

<style lang="scss" scoped>
.pre-audit {
    .steps-wrapper {
        width: 900px;
        margin: 0 auto;
        margin-bottom: 30px;
        // 引入定制化步骤条
        @import '../../common/costom-el-steps';
    }
    .form-wrapper {
        width: 460px;
        margin: 0 auto;
    }
    .btns-wrapper {
        width: 460px;
        margin: 0 auto;
        text-align: center;
    }
}
.click-wrapper {
    display: inline-block;
}
.form-text {
    font-size: 14px;
    color: #606266;
    font-weight: 700;
    display: inline-block;
}
</style>
